import { render, staticRenderFns } from "./ITable.vue?vue&type=template&id=1f09d095&scoped=true"
import script from "./ITable.vue?vue&type=script&lang=js"
export * from "./ITable.vue?vue&type=script&lang=js"
import style0 from "./ITable.vue?vue&type=style&index=0&id=1f09d095&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f09d095",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f09d095')) {
      api.createRecord('1f09d095', component.options)
    } else {
      api.reload('1f09d095', component.options)
    }
    module.hot.accept("./ITable.vue?vue&type=template&id=1f09d095&scoped=true", function () {
      api.rerender('1f09d095', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ITable.vue"
export default component.exports